import dayjs from 'dayjs'
import relativeTime from 'dayjs/plugin/relativeTime'
import {
  shortenUUIDs
} from '@/utils/utils.js'

dayjs.extend(relativeTime)

export const filters = {
  dateFormat: function (value, format = 'MM-DD-YYYY HH:mm') {
    if (value) {
      const d = new Date(value.toString())
      let tz = Intl.DateTimeFormat().resolvedOptions().timeZone || 'UTC'
      // timeZone running test in iTerm is not null
      if (process.env.NODE_ENV && process.env.NODE_ENV === 'test') {
        tz = 'UTC'
      }
      const localDate = d.toLocaleString("en-US", { timeZone: tz })
      const newDate = dayjs(localDate).format(format)
      return newDate
    }
    return null
  },
  dateFromFormat: function (value) {
    if (value) {
      const d = new Date(value.toString())
      let tz = Intl.DateTimeFormat().resolvedOptions().timeZone || 'UTC'
      // timeZone running test in iTerm is not null
      if (process.env.NODE_ENV && process.env.NODE_ENV === 'test') {
        tz = 'UTC'
      }
      const localDate = d.toLocaleString("en-US", {
        timeZone: tz
      })
      const now = dayjs()
      const newDate = dayjs(localDate)
      return newDate.from(now)
    }
    return null
  },
  shortenUUID: function (value) { 
    return shortenUUIDs([value])[0]
  }
}